import React, { FC } from 'react';
import { PaymentsComparisonLink } from 'components/PaymentsComparisonLink/PaymentsComparisonLink';
import { TextV2 } from '../../TextV2/TextV2';
import styles from './TextWithPaymentsComparisonLink.module.scss';

const paymentsComparisonLinkText = '<PAYMENTS_COMPARISON_LINK>';

interface ITextWithPaymentsComparisonLinkProps {
  text: string;
  textColor?: string;
  link?: string;
  className?: string;
}

/**
 * Renders the provided text while replacing instances of `<PAYMENTS_COMPARISON_LINK>`
 * with the `PaymentsComparisonLink` component if found.
 *
 * @param text - The text to render.
 * @param textColor - The color of the link text.
 * @param linkText - The text link name.
 * @param className - the text link class name.
 * @constructor
 */

const newLine = '\n';

const splitTextByNewLine = (text: string): string[] => {
  return text.trimEnd().indexOf(newLine) > 0 ? text.split(newLine) : [];
};

const getNonLinkText = (textChunks: string[], text: string): string => {
  return textChunks.length > 0 ? textChunks[0] : text;
};

const getLastBlockText = (textBlurb: string): string => {
  const textChunks = splitTextByNewLine(textBlurb);
  return textChunks.length > 0 ? textChunks[textChunks.length - 1] : '';
};

export const TextWithPaymentsComparisonLink: FC<ITextWithPaymentsComparisonLinkProps> = ({
  text,
  textColor,
  link,
  className,
}) => {
  return (
    <>
      {text.split(paymentsComparisonLinkText).map((nonLinkText, index, array) => {
        const isLastTextChunk = index === array.length - 1;
        const nonLinkTextChunks = splitTextByNewLine(nonLinkText);
        const nonMarkDownText = getNonLinkText(nonLinkTextChunks, nonLinkText);
        const lastBlockText = getLastBlockText(nonLinkText);

        return (
          <React.Fragment key={index}>
            {nonMarkDownText}
            {!isLastTextChunk && (
              <PaymentsComparisonLink className={className} textLinkColor={textColor} textLink={link} />
            )}
            {isLastTextChunk && (
              <TextV2
                value={lastBlockText}
                isMarkdown
                className={styles.onlineOnlyPricingDisclaimer}
              ></TextV2>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
